// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"2b131fc2","370":"d2122274","421":"1a493ea4","504":"6e2df2f8","784":"30c0a86b","901":"d8f39f20"}[chunkId] + ".chunk.js";
};